<span class="flex text-xs">
  <span class="my-auto mr-2">Company Score =</span>
  <span>
    FTE * (1 + FTE growth rate)
    <span class="block border-t-2 text-center">1 + PIC</span>
  </span>
</span>